import style from './style.module.scss';
const MoreInformation = ({ info = [], canEdit, editBtnEvent = () => {}, hideEditBtn = false }) => {
  return (
    <div className={style.moreInformationClass}>
      {info?.map(({ title, heading, before, after }, index) => (
        <div key={index} style={{ display: 'flex', gap: '24px' }}>
          {before?.title && before?.heading && (
            <div>
              {before.heading && <p className={style.heading}>{before.heading}</p>}
              {before.title && <p className={style.title}>{before.title}</p>}
            </div>
          )}
          <div
            style={{
              width: '100%'
            }}
          >
            {heading === 'License # - line #' ? (
              <div className={style['grid-2']} style={{ marginTop: '0px' }}>
                <div
                  style={{
                    maxWidth: '100%'
                  }}
                >
                  {title?.licenseNum && <p className={style.heading}>License #</p>}
                  {title?.licenseNum && <p className={style.title}>{title?.licenseNum}</p>}
                </div>

                <div
                  style={{
                    maxWidth: '100%'
                  }}
                >
                  {title?.lineNum && <p className={style.heading}>line #</p>}
                  {title?.lineNum && <p className={style.title}>{title?.lineNum}</p>}
                </div>
              </div>
            ) : heading === 'Jurisdiction - jurisdictionNumber' ? (
              <div className={style['grid-2']} style={{ marginTop: '0px' }}>
                <div
                  style={{
                    maxWidth: '100%'
                  }}
                >
                  {title?.jurisdiction && <p className={style.heading}>Jurisdiction</p>}
                  {title?.jurisdiction && <p className={style.title}>{title?.jurisdiction}</p>}
                </div>

                <div
                  style={{
                    maxWidth: '100%'
                  }}
                >
                  {title?.jurisdictionNumber && <p className={style.heading}>Jurisdiction #</p>}
                  {title?.jurisdictionNumber && (
                    <p className={style.title}>{title?.jurisdictionNumber}</p>
                  )}
                </div>
              </div>
            ) : (
              <>
                {heading && <p className={style.heading}>{heading}</p>}
                {title && (
                  <p
                    className={style.title}
                    style={{
                      marginBottom: index === info?.length - 1 ? '0px' : '24px'
                    }}
                  >
                    {title}
                  </p>
                )}
              </>
            )}
          </div>
          {after?.title && after?.heading && (
            <div>
              {after.heading && <p className={style.heading}>{after.heading}</p>}
              {after.title && <p className={style.title}>{after.title}</p>}
            </div>
          )}
        </div>
      ))}
      {!hideEditBtn && (
        <button
          className={`${style.editBtn} ${!canEdit && style.editBtnDisabled} `}
          disabled={!canEdit}
          onClick={editBtnEvent}
        >
          EDIT
        </button>
      )}
    </div>
  );
};

export default MoreInformation;
